import { JSONSchema7 } from "json-schema";

export const ExplainClarityMetadataSchema: JSONSchema7 = {
  description: "Clarity explanation.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
